import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import sologo from '../assets/images/sologo.png';
import logoTrilha from '../assets/images/logo_trilha.png';
import Form from './incubacaoAvaliacaoForm';

import imagemFundo from '../assets/images/trilhaConhecimento/fundo.png';
import { setModoTela, initForm, salvar, getLista, getListaUsuario } from './incubacaoAvaliacaoActions';
import { getLista as getListaTexto } from '../texto/textoActions';
import { getLista as getListaVideo } from '../video/videoActions';
import TextoInput from '../texto/textoInput';
import consts from '../consts';

class IncubacaoAvaliacao extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {
		this.props.getLista();
		this.props.getListaUsuario();

		this.props.getListaTexto();
		this.props.getListaVideo();
	}

    componentWillMount() {
    }

    render() {

		let incubacaoAvaliacaoAberta = this.props.lista.filter(item => item.id_usuario == this.props.sessao.id || (item.id_empreendedores || []).includes(this.props.sessao.id))[0];
		if (this.props.sessao.administrador) {
			incubacaoAvaliacaoAberta = this.props.incubacaoAvaliacaoCarregada || this.props.lista[0];
		}
		
		let fundo = imagemFundo;
		// if (this.props.modoTela == 'ideacao') {
		// 	fundo = imagemFundoIdeacao;
		// }

        return (
            <Background
				imagem={fundo}
				backgroundPosition={'center'}
				gradientStart='#0F2748'
				gradientEnd='#0F2748'>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'trilha' ? this.inicial(incubacaoAvaliacaoAberta) : null}
					
					{this.props.modoTela == 'cadastro' ? <Form onSubmit={this.props.salvar} /> : null}

					{/* {this.props.modoTela == 'incubacaoPlanejamento' ? <IncubacaoPlanejamento incubacao={incubacaoAberta} /> : null} */}

                </Content>
            </Background>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<Row alignCenter>
				<Grid cols='12 10 8 6'>
					<ContentCard>
						<ContentCardBody>
							<Row alignCenter 
								style={{ 
									padding: 16
								}}>
								
								<Grid cols='12 10 6 4'>
									<Button
										text='Iniciar Nova Trilha'
										type={'primary'}
										icon={'fa fa-plus'}
										event={() => {
											this.props.setModoTela('cadastro', {});
											this.props.initForm({});
										}} />
								</Grid>
							</Row>
						</ContentCardBody>
					</ContentCard>
				</Grid>

				{lista.length > 0  &&
				<Grid cols='12 12 12 12'>
					<ContentCard>
						<ContentCardBody>
							<Table responsive>
								<THead>
									<Tr>
										<Th>Nome do Projeto</Th>
										<Th alignCenter>Data/Hora</Th>
										<Th alignCenter>Enviada Por</Th>
										<Th></Th>
									</Tr>
								</THead>
								<TBody>
									{lista.map(item => (
										<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
											onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
											onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
											<Td>{item.nome_projeto}</Td>
											<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
											<Td alignCenter>{item.nome_usuario}</Td>
											<Td alignRight minWidth={150}>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-eye'}
													visible={this.state.linhaSelecionada == item.id}
													event={() => {
														this.props.setModoTela('visualizacao', {
															...item
														});
														this.props.initForm({
															...item
														});
													}} />
											</Td>
										</Tr>
									))}
								</TBody>
							</Table>
						</ContentCardBody>
					</ContentCard>
				</Grid>}
			</Row>
		);
	}

	inicial(incubacaoAvaliacaoAberta) {

		return (
			<>
				<Row alignCenter 
					style={{ 
						padding: 16,
						marginTop: 20
					}}>
					<Grid cols='12 10 8 6'>
						<h2 style={{ textAlign: 'center', color: '#ffffff', fontSize: 'clamp(1rem, 2.5vw, 1.5rem)', margin: 0, padding: 0 }}>{this.props.incubacaoAvaliacaoTitulo}</h2>
						
						<TextoInput chave='incubacaoAvaliacaoTitulo' />
					</Grid>
				</Row>
				<Row alignCenter>
					{(!incubacaoAvaliacaoAberta || this.props.sessao.administrador) &&
					<Grid cols='12 10 8 6'>
						<ContentCard
							style={{
								marginTop: 20,
								backgroundColor: '#0F2748',
								color: '#ffffff',
								borderRadius: 20,
								boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
								opacity: '80%'
							}}>
							<ContentCardBody>
								<Row alignCenter 
									style={{ 
										padding: 16
									}}>
									<Grid cols='12 12 12 12'>
										<h4 style={{ textAlign: 'center' }}>{this.props.incubacaoAvaliacaoTituloNaoIniciada}</h4>

										<TextoInput chave='incubacaoAvaliacaoTituloNaoIniciada' />
									</Grid>
									<Grid cols='12 12 12 12' style={{ padding: 16 }}>
										<p style={{ textAlign: 'center' }}>{this.props.incubacaoAvaliacaoDescricaoNaoIniciada}</p>

										<TextoInput chave='incubacaoAvaliacaoDescricaoNaoIniciada' />
									</Grid>
								</Row>
							</ContentCardBody>
						</ContentCard>
					</Grid>}
					
				</Row>

				{incubacaoAvaliacaoAberta ? this.trilha(incubacaoAvaliacaoAberta) : null}

			</>
		);
	}

	trilha(incubacaoAvaliacaoAberta) {

		// const registroincubacaoAvaliacaoPlanejamento = this.props.listaPlanejamento.filter(item => item.id_incubacaoAvaliacao == incubacaoAvaliacaoAberta.id)[0];
		// const registroIncubacaoMeta = this.props.listaMeta.filter(item => item.id_incubacao == incubacaoAberta.id)[0];
		// const registroIncubacaoConsultoria = this.props.listaConsultoria.filter(item => item.id_incubacao == incubacaoAberta.id)[0];
		// const registroIncubacaoMaturidadeAno1 = this.props.listaMaturidadeAno1.filter(item => item.id_incubacao == incubacaoAberta.id)[0];
		// const registroIncubacaoMaturidadeAno2 = this.props.listaMaturidadeAno2.filter(item => item.id_incubacao == incubacaoAberta.id)[0];
		// const registroIncubacaoMaturidadeAno3 = this.props.listaMaturidadeAno3.filter(item => item.id_incubacao == incubacaoAberta.id)[0];

		return (
			<Row alignCenter>
				
				<Grid cols='12 12 10 8'>

					{this.props.listaVideo.map(item => (
						<Row key={item.id} alignCenter style={{ padding: 8, marginTop: 20 }}>
							<Grid cols='12 12 8 6'>
								<div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9' }}>
									<iframe
										width="100%"
										height="100%"
										src={item.link}
										allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
										allowFullScreen></iframe>
								</div>
							</Grid>
						</Row>
					))}

					{(this.props.sessao.administrador && this.props.incubacaoCarregada) &&
					<Row alignCenter style={{ padding: 8, marginTop: 20 }}>
						<Grid cols='10 8 6 4'>
							<button 
								type='button'
								class='btn btn-trilha btn-block btn-flat'
								onClick={() => this.props.eventoAdm()}>
								Voltar para Lista
							</button>
						</Grid>
					</Row>}


				</Grid>
				
			</Row>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.incubacao.modoTela,
	aguardando: state.incubacao.aguardando,
	lista: state.incubacao.lista,
	listaPlanejamento: state.incubacaoPlanejamento.lista,
	listaMeta: state.incubacaoMeta.lista,
	listaConsultoria: state.incubacaoConsultoria.lista,
	listaMaturidadeAno1: state.incubacaoMaturidadeAno1.lista,
	listaMaturidadeAno2: state.incubacaoMaturidadeAno2.lista,
	listaMaturidadeAno3: state.incubacaoMaturidadeAno3.lista,
	incubacaoTitulo: state.texto.lista.filter(item => item.chave == 'incubacaoTitulo').map(item => item.valor)[0],
	incubacaoTituloNaoIniciada: state.texto.lista.filter(item => item.chave == 'incubacaoTituloNaoIniciada').map(item => item.valor)[0],
	incubacaoDescricaoNaoIniciada: state.texto.lista.filter(item => item.chave == 'incubacaoDescricaoNaoIniciada').map(item => item.valor)[0],
	listaVideo: state.video.lista.filter(item => item.trilha == 'incubacao')
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getListaTexto, getListaVideo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoAvaliacao);
